// hooks/useSecurityTransfer.js
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { getPublicSecuritiesOptions, transferSecurity } from '../../api/TransfertTitre/securityTransferService';

export const useSecurityTransfer = (accountId, domainId, onSuccess) => {
  const [isLoading, setIsLoading] = useState(false);
  const [securities, setSecurities] = useState([]);
  const [formData, setFormData] = useState({
    securityId: '',
    quantity: '',
    preuve: null,
  });
  const [errors, setErrors] = useState({});

  // Charger les titres disponibles
  useEffect(() => {
    if (domainId) {
      loadSecurities();
    }
  }, [domainId]);

  const loadSecurities = async () => {
    try {
      const securitiesList = await getPublicSecuritiesOptions(domainId);
      setSecurities(securitiesList);
    } catch (error) {
      toast.error('Erreur lors du chargement des titres');
    }
  };

  const validateForm = (isAdd) => {
    const newErrors = {};

    if (!formData.securityId) {
      newErrors.securityId = 'Veuillez sélectionner un titre';
    }

    if (!formData.quantity || parseInt(formData.quantity) <= 0) {
      newErrors.quantity = 'La quantité doit être supérieure à 0';
    }

    if (!formData.preuve) {
      newErrors.preuve = 'La preuve de transaction est obligatoire';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (isAdd) => {
    if (!validateForm(isAdd)) {
      toast.error('Veuillez corriger les erreurs dans le formulaire');
      return;
    }

    setIsLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('accountId', isAdd ? accountId : '');
      formDataToSend.append('toAccountId', isAdd ? '' : accountId);
      formDataToSend.append('securityId', formData.securityId);
      formDataToSend.append('quantity', formData.quantity);
      formDataToSend.append('domainId', domainId);
      if (formData.preuve) {
        formDataToSend.append('Preuve', formData.preuve);
      }

      const result = await transferSecurity(formDataToSend, isAdd);

      if (result.success) {
        toast.success(result.message);
        resetForm();
        onSuccess?.();
      } else {
        toast.error(result.message || 'Opération échouée');
      }
    } catch (error) {
      toast.error(error.message || 'Une erreur est survenue');
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      securityId: '',
      quantity: '',
      preuve: null,
    });
    setErrors({});
  };

  const updateField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Effacer l'erreur quand l'utilisateur corrige
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  return {
    formData,
    errors,
    isLoading,
    securities,
    updateField,
    handleSubmit,
    resetForm,
  };
};